export const getSignedAmount = (amount: number, isCreditNote?: boolean) => (isCreditNote ? -amount : amount)
